module.exports = __webpack_public_path__ + "media/images/best-of-year-65ee29e8ac8632f7d4cbde001fae39a5.svg";